// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC3UzXBk53RXdXMVGPWI5DMkJYl5l8y8Kk",
    authDomain: "portafoliocaritodasilva.firebaseapp.com",
    databaseURL: "https://portafoliocaritodasilva.firebaseio.com",
    projectId: "portafoliocaritodasilva",
    storageBucket: "portafoliocaritodasilva.appspot.com",
    messagingSenderId: "564749230526"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
